/**
 * filter-apply-button.js — Jewels Park Wholesale (Minimog Theme)
 * v9 — correct selectors from DOM inspection
 *
 * Structure confirmed:
 *   <section class="facest-filters-section sidebar-open">   ← open indicator
 *     <collection-filters-form class="m-collection-filters-form m-filter--widget">
 *       <div class="m-filter--wrapper m:flex m:flex-col">   ← append footer HERE
 *         <form>
 *           <div class="m-filter--widget"> (repeated per filter group)
 *             <ul class="m-facets">
 *               <li class="m-facet--item">  ← overlay goes here
 *
 * INSTALL:
 *   layout/theme.liquid → first script in <head> (no defer):
 *   <script src="{{ 'filter-apply-button.js' | asset_url }}"></script>
 */
(function () {
  'use strict';

  const GOLD   = '#C9922A';
  const DARK   = '#1A1612';
  const BORDER = '#E2D9CF';
  const MUTED  = '#7A6E65';

  // ── State ────────────────────────────────────────────────────────────────────
  const _selected = new Map(); // key → Set of values
  let _ready = false;

  // ── Load current filter state from URL ────────────────────────────────────────
  function loadFromUrl() {
    _selected.clear();
    new URL(window.location.href).searchParams.forEach((val, key) => {
      if (key.startsWith('filter.')) {
        if (!_selected.has(key)) _selected.set(key, new Set());
        _selected.get(key).add(val);
      }
    });
  }

  // ── Block <collection-filters-form> from navigating ──────────────────────────
  // The custom element listens for 'change' events and calls fetch+pushState.
  // We block pushState; fetch goes through (it's the section AJAX load, harmless).
  const _origPush    = history.pushState.bind(history);
  const _origReplace = history.replaceState.bind(history);

  history.pushState = function (s, t, url) {
    if (_ready && url && String(url).includes('filter.')) {
      // Store for Apply but don't navigate
      return;
    }
    return _origPush(s, t, url);
  };

  history.replaceState = function (s, t, url) {
    if (_ready && url && String(url).includes('filter.')) return;
    return _origReplace(s, t, url);
  };

  // ── CSS ───────────────────────────────────────────────────────────────────────
  function injectCSS() {
    if (document.getElementById('jp-css')) return;
    const s = document.createElement('style');
    s.id = 'jp-css';
    s.textContent = `
      /* Overlay on each filter item */
      .m-facet--item { position: relative !important; }
      .jp-overlay {
        position: absolute;
        inset: 0;
        z-index: 20;
        cursor: pointer;
        background: transparent;
      }

      /* Footer sticky inside the sidebar scroll container */
      .jp-footer {
        position: sticky;
        bottom: 0;
        left: 0;
        right: 0;
        z-index: 999999;
        display: flex;
        gap: 10px;
        padding: 14px 20px 24px;
        background: #ffffff;
        border-top: 2px solid #000000;
        /* Negative margin to cancel any wrapper padding */
        margin-left: -16px;
        margin-right: -16px;
        padding-left: 20px;
        padding-right: 20px;
      }
      .jp-apply {
        flex: 1;
        padding: 14px 16px;
        background: #ffffff;
        color: #000000;
        border: 2px solid #000000;
        border-radius: 4px;
        font-size: 12px;
        font-weight: 700;
        letter-spacing: 1px;
        text-transform: uppercase;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        font-family: inherit;
        transition: background 0.15s, color 0.15s;
      }
      .jp-apply:hover {
        background: #000000;
        color: #ffffff;
      }
      .jp-apply:active { transform: scale(0.98); }
      .jp-apply.jp-on {
        background: #000000;
        color: #ffffff;
        animation: none;
      }
      .jp-apply.jp-on:hover {
        background: #333333;
        color: #ffffff;
      }
      .jp-n {
        background: #000000;
        color: #ffffff;
        border-radius: 10px;
        padding: 1px 8px;
        font-size: 11px;
        min-width: 20px;
        text-align: center;
      }
      .jp-apply.jp-on .jp-n {
        background: #ffffff;
        color: #000000;
      }
      .jp-clear {
        padding: 14px 18px;
        background: #ffffff;
        color: #000000;
        border: 2px solid #000000;
        border-radius: 4px;
        font-size: 11px;
        font-weight: 700;
        letter-spacing: 0.5px;
        text-transform: uppercase;
        cursor: pointer;
        white-space: nowrap;
        font-family: inherit;
        transition: background 0.15s, color 0.15s;
      }
      .jp-clear:hover {
        background: #000000;
        color: #ffffff;
      }
      @keyframes jp-pulse {
        0%,100% { box-shadow: 0 0 0 0 rgba(0,0,0,0.3); }
        50%      { box-shadow: 0 0 0 8px rgba(0,0,0,0); }
      }
    `;
    document.head.appendChild(s);
  }

  // ── Count total selected ──────────────────────────────────────────────────────
  function totalSelected() {
    let n = 0;
    _selected.forEach(v => { n += v.size; });
    return n;
  }

  // ── Refresh button labels ─────────────────────────────────────────────────────
  function refreshBtns() {
    const n = totalSelected();
    document.querySelectorAll('.jp-apply').forEach(btn => {
      btn.innerHTML = n > 0
        ? `Apply Filters <span class="jp-n">${n}</span>`
        : 'Apply Filters';
      btn.classList.toggle('jp-on', n > 0);
    });
  }

  // ── Build navigate URL from _selected ────────────────────────────────────────
  function buildUrl() {
    const url = new URL(window.location.href);
    [...url.searchParams.keys()].forEach(k => {
      if (k.startsWith('filter.') || k === 'page') url.searchParams.delete(k);
    });
    _selected.forEach((vals, key) => {
      vals.forEach(val => url.searchParams.append(key, val));
    });
    return url.toString();
  }

  // ── Overlay click: toggle selection without triggering Minimog ───────────────
  function handleOverlayClick(e, item) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const cb = item.querySelector('input[type="checkbox"], input[type="radio"]');
    if (!cb) return;

    const key = cb.name;
    const val = cb.value;

    if (!_selected.has(key)) _selected.set(key, new Set());
    const vals = _selected.get(key);

    if (cb.type === 'radio') {
      // Radio: clear group then select this one
      vals.clear();
      vals.add(val);
      cb.checked = true;
      // Uncheck siblings
      document.querySelectorAll(`input[type="radio"][name="${key}"]`).forEach(r => {
        r.checked = r.value === val;
      });
    } else {
      // Checkbox: toggle
      if (vals.has(val)) {
        vals.delete(val);
        cb.checked = false;
      } else {
        vals.add(val);
        cb.checked = true;
      }
    }

    refreshBtns();
  }

  // ── Inject overlays on all .m-facet--item elements ───────────────────────────
  function injectOverlays() {
    document.querySelectorAll('.m-facet--item').forEach(item => {
      if (item.querySelector('.jp-overlay')) return;
      const cb = item.querySelector('input[type="checkbox"], input[type="radio"]');
      if (!cb) return;

      // Sync visual state from _selected
      const key = cb.name;
      const val = cb.value;
      const isSelected = _selected.has(key) && _selected.get(key).has(val);
      cb.checked = isSelected;

      const overlay = document.createElement('div');
      overlay.className = 'jp-overlay';
      overlay.addEventListener('click', e => handleOverlayClick(e, item), true);
      item.appendChild(overlay);
    });
  }

  // ── Build footer ──────────────────────────────────────────────────────────────
  function buildFooter() {
    const footer = document.createElement('div');
    footer.className = 'jp-footer';

    const clearBtn = document.createElement('button');
    clearBtn.type = 'button';
    clearBtn.className = 'jp-clear';
    clearBtn.textContent = 'Clear All';
    clearBtn.addEventListener('click', () => {
      _ready = false;
      const url = new URL(window.location.href);
      [...url.searchParams.keys()].forEach(k => {
        if (k.startsWith('filter.') || k === 'page') url.searchParams.delete(k);
      });
      window.location.href = url.toString();
    });

    const applyBtn = document.createElement('button');
    applyBtn.type = 'button';
    applyBtn.className = 'jp-apply';
    applyBtn.textContent = 'Apply Filters';
    applyBtn.addEventListener('click', () => {
      _ready = false;
      window.location.href = buildUrl();
    });

    footer.appendChild(clearBtn);
    footer.appendChild(applyBtn);
    return footer;
  }

  // ── Inject footer into .m-sidebar--content (the scrollable container) ─────────
  function injectFooter() {
    if (document.querySelector('.jp-footer')) return;

    // .m-sidebar--content is the scrollable div — sticky works correctly inside it
    const target = document.querySelector('.m-sidebar--content')
                || document.querySelector('.m-filter--wrapper')
                || document.querySelector('.m-sidebar');
    if (!target) return;

    target.appendChild(buildFooter());
    refreshBtns();
  }

  // ── Watch for sidebar open/close (section gets "sidebar-open" class) ──────────
  function watchSidebar() {
    let wasOpen = false;

    const obs = new MutationObserver(() => {
      const section = document.querySelector('section.facest-filters-section, section[class*="filter"]');
      const isOpen  = section ? section.classList.contains('sidebar-open') : false;

      if (isOpen && !wasOpen) {
        // Drawer just opened
        _ready = true;
        setTimeout(() => {
          injectOverlays();
          injectFooter();
          refreshBtns();
        }, 100);
      } else if (!isOpen && wasOpen) {
        // Drawer closed
        _ready = false;
      }

      wasOpen = isOpen;
    });

    obs.observe(document.body, {
      attributes: true,
      attributeFilter: ['class'],
      subtree: true,
    });
  }

  // ── Also watch for new .m-facet--item being added (accordion expand) ──────────
  function watchNewItems() {
    const obs = new MutationObserver(() => {
      if (_ready) injectOverlays();
    });
    obs.observe(document.body, { childList: true, subtree: true });
  }

  // ── Init ─────────────────────────────────────────────────────────────────────
  function init() {
    // The jp-filter grid (sections/jp-filter-grid.liquid) filters in the browser:
    // there is no #CollectionFiltersForm to submit and no `filter.*` URL to build,
    // so staging + Apply has nothing to apply to. Its ticks take effect instantly
    // instead. Leaving this script active there would overlay the facets and
    // navigate away on Apply, so bail out.
    if (document.querySelector('[data-jpf]')) return;

    injectCSS();
    loadFromUrl();
    watchSidebar();
    watchNewItems();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();